export var EAppActions;
(function (EAppActions) {
    /* -------------------------------------------------------------------------------------------------
     * App
     * -----------------------------------------------------------------------------------------------*/
    EAppActions["CONNECT_WALLET_OPEN"] = "CONNECT_WALLET_OPEN";
    EAppActions["SET_CONNECTED_WALLET"] = "SET_CONNECTED_WALLET";
    EAppActions["SET_OFFCANVAS_OPEN"] = "SET_OFFCANVAS_OPEN";
    EAppActions["SET_NETWORK_OPEN"] = "SET_NETWORK_OPEN";
    EAppActions["SET_ERROR_REPORTING_ENABLED"] = "SET_ERROR_REPORTING_ENABLED";
    /* -------------------------------------------------------------------------------------------------
     * Exchange
     * -----------------------------------------------------------------------------------------------*/
    EAppActions["SET_ASSET_SELECT_CONTEXT"] = "SET_ASSET_SELECT_CONTEXT";
    EAppActions["SET_ASSET_SELECT_OPEN"] = "SET_ASSET_SELECT_OPEN";
    EAppActions["SET_EXCHANGE_INPUT_VALUE"] = "SET_EXCHANGE_INPUT_VALUE";
    EAppActions["SET_EXCHANGE_OUTPUT_VALUE"] = "SET_EXCHANGE_OUTPUT_VALUE";
})(EAppActions || (EAppActions = {}));
export var ExchangeMode;
(function (ExchangeMode) {
    ExchangeMode["buy"] = "buy";
    ExchangeMode["sell"] = "sell";
    ExchangeMode["swap"] = "swap";
    ExchangeMode["default"] = "buy";
})(ExchangeMode || (ExchangeMode = {}));
export var ExchangeOrderType;
(function (ExchangeOrderType) {
    ExchangeOrderType["market"] = "market";
    ExchangeOrderType["limit"] = "limit";
    ExchangeOrderType["default"] = "market";
})(ExchangeOrderType || (ExchangeOrderType = {}));
//# sourceMappingURL=types.js.map